<template>
  <div v-if="(sideShow&&menuList.length>0)" class="body_right" :style="{
    width: `${initData.sideBarWidth}px`,
  }">
    <el-tabs v-model="activeName" class="side_top" type="card" :before-leave="handleClick">

      <el-tab-pane v-for="item in menuList" :key="item.sidebarId" :label="item.menuName" :name="item.sidebarId">

        <span slot="label" v-if="(item.menuType == 4)">
          <el-link type="primary" :underline="false">{{
              item.menuName
          }}</el-link>
        </span>

        <div class="side_bottom" v-if="(item.menuType == 2)">
          <div class="p10" v-html="item.customContent"></div>
        </div>
        <div class="side_bottom" v-if="(item.menuType == 1)">
          <div class="logo">
            <img :src="customer.adminFace || initData.robotIcon || avator" />
            <p class="company">{{ initData.titleDesc }}</p>
          </div>
        </div>
        <div class="side_bottom" v-if="(item.menuType == 3)">
          <iframe class="w100h100" :src="item.menuUrl" frameborder="0"></iframe>
        </div>
      </el-tab-pane>

    </el-tabs>

  </div>
</template>

<script>

import avator from "../../../static/image/custom.png";
export default {
  name: "side",
  data() {
    return {
      sideShow: true,
      activeName: '',
      avator: avator,
      menuList: [
      ],

    }
  },
  watch: {
    initData() {
      this.sideShow = this.$store.state.initData.sideBarStatus;
      this.menuList = this.$store.state.initData.sideBarList;
      if (this.sideShow && this.menuList.length > 0) {
        this.activeName = this.$store.state.initData.sideBarList[0].sidebarId
      }
      
      return this.$store.state.initData;
    }
  },
  computed: {
    initData() {
      this.sideShow = this.$store.state.initData.sideBarStatus;
      this.menuList = this.$store.state.initData.sideBarList;
      if (this.sideShow && this.menuList.length > 0) {
        this.activeName = this.$store.state.initData.sideBarList[0].sidebarId
      }
      
      return this.$store.state.initData;
    },
    customer() {
      return this.$store.state.customer;
    },
  },
  mounted() {

  },
  methods: {
    handleClick(newIndex, oldIndex) {
      this.menuList.forEach(item => {
        if (newIndex == item.sidebarId) {
          if (item.menuType == 4) {
            setTimeout(() => {
              window.open(item.url, "_blank");
            }, 500)
            console.log('lanjie')
            return false
          } else {
            return true
          }
        } else {
          return true
        }
      })

    }
  }
}
</script>

<style scoped>
.body_right {
  border-left: .5px solid #e6e6e6;
  display: flex;
  flex-direction: column;
  text-align: left;
  font-size: 14px;
  width: 260px;
}

.side_top /deep/ .el-icon-arrow-left {
  line-height: 40px;
}

.side_top /deep/ .el-icon-arrow-right {
  line-height: 40px;
}

/* .side_top /deep/ .el-tabs__content {
  height: calc(100% - 150px);
} */

.side_top {
  /* height: 245px; */
  border-bottom: .5px solid #e6e6e6;
  /* padding: 17px 20px; */
}

.side_title {
  font-size: 16px;
  color: #2a2a2c;
  margin-bottom: 10px;
}

.side_desc {
  color: #666666;
}

.side_bottom {
  flex: 1;
  /* padding: 17px 20px; */
  height: 574px;
}

/* .side_bottom>div {
  font-size: 14px;
  color: #666666;
  line-height: 32px;
  border-bottom: .5px solid #e6e6e6;
} */

p {
  margin: 0;
}


.logo {
  flex: 7;
  text-align: left;
  overflow: hidden;
  display: flex;
}

.logo img {
  width: 36px;
  height: 36px;
  margin: 13px 10px 13px 20px;
  border-radius: 50%;
}

.logo .company {
  font-size: 14px;
  color: #000;
  line-height: 60px;
  flex: 1;
}

.w100h100 {
  height: 100%;
  width: 100%;
}

.p10 {
  padding: 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/pc/side.vue